import { useGLTF } from '@react-three/drei'
import { useEffect, useMemo } from 'react'
import OvniMerged from './OvniMerged'
import Controls from '../Controler'
import Floor from './Floor'
import { CliffOne, Arche, CliffTwo, CliffThree, Dalle } from './Decors'
import { CuboidCollider, Physics, RigidBody } from '@react-three/rapier'
import { useSceneRef } from '../../../RefsProvider'
import { InfoControls } from './TextFour'
import InterestPoint from './InterestPoint'
import Projects from './Projects'
import { useInterestPointStore } from '../../../store/uneInterestPointsStore'
import CameraGradient from './CameraGradient'
import Particles from './Particles'



export default function ActeFourModels({ setRefModel, camRef }) {

    const { nodes } = useGLTF('./models/04/emptiesMap.glb')
    const acteFourModelRefBloom = useSceneRef("acteThreeModelRef")
   
    

    const cliffOneEmpties = useMemo(
        () => Object.values(nodes).filter((n) => n.name.includes('cliff01')),
        [nodes]
    )
    const cliffTwoEmpties = useMemo(
        () => Object.values(nodes).filter((n) => n.name.includes('cliff02')),
        [nodes]
    )
    const cliffThreeEmpties = useMemo(
        () => Object.values(nodes).filter((n) => n.name.includes('cliff04')),
        [nodes]
    )
    const dalleEmpties = useMemo(
        () => Object.values(nodes).filter((n) => n.name.includes('stair02')),
        [nodes]
    )
    const interestPoints = [
        {
            id: 1,
            position: [1, 0, 10],
        },
        {
            id: 2,
            position: [-30, 0, 22],
        },
        {
            id: 3,
            position: [-37, 0, 40],
        },
        {
            id: 4,
            position: [-10, 0, 56.5],
        },
        {
            id: 5,
            position: [6, 0, 48],
        },
        {
            id: 6,
            position: [3, 0, 36],
        },
        {
            id: 7,
            position: [18, 0, 27],
        },
        {
            id: 8,
            position: [31, 0, 38],
        },
        {
            id: 9,
            position: [31, 0, 51],
        },
        {
            id: 10,
            position: [19, 0, 51],
        },
        {
            id: 11,
            position: [43, 0, 51],
        },
        {
            id: 12,
            position: [31, 0, 64],
        },
        {
            id: 13,
            position: [19, 0, 64],
        },
        {
            id: 14,
            position: [43, 0, 64],
        },
    ]
    useEffect(() => {
        useInterestPointStore.getState().initInterestPoints(interestPoints)
    }, [interestPoints])

    return (
        <>  
            <Particles />
            <Physics interpolate>
                <group ref={acteFourModelRefBloom}>
                    <CameraGradient camRef={camRef}/>
                    <OvniMerged setRefModel={setRefModel} />
                    <Controls />
                    <Floor />

                    {cliffOneEmpties.map((empty) => (
                        <CliffOne
                            key={empty.uuid}
                            position={[empty.position.x, -5, empty.position.z]}
                            rotation={[empty.rotation.x, empty.rotation.y, empty.rotation.z]}
                            scale={[empty.scale.x, empty.scale.y, empty.scale.z]}
                        />
                    ))}

                    {cliffTwoEmpties.map((empty) => (
                        <CliffTwo
                            key={empty.uuid}
                            position={[empty.position.x, -5, empty.position.z]}
                            rotation={[empty.rotation.x, empty.rotation.y, empty.rotation.z]}
                            scale={[empty.scale.x, empty.scale.y, empty.scale.z]}
                        />
                    ))}

                    {cliffThreeEmpties.map((empty) => (
                        <CliffThree
                            key={empty.uuid}
                            position={[empty.position.x, -5, empty.position.z]}
                            rotation={[empty.rotation.x, empty.rotation.y, empty.rotation.z]}
                            scale={[empty.scale.x, empty.scale.y, empty.scale.z]}
                        />
                    ))}

                    {dalleEmpties.map((empty, index) => (
                        <Dalle
                            key={empty.uuid}
                            index={index}
                            position={[empty.position.x, empty.position.y, empty.position.z]}
                            rotation={[empty.rotation.x, empty.rotation.y, empty.rotation.z]}
                            scale={[empty.scale.x, empty.scale.y, empty.scale.z]}
                        />
                    ))}

                    <Arche position={[0, -3, 0]} scale={[4, 4, 4]} />
                    <InfoControls rotation={[Math.PI * 0.5, Math.PI * 1, 0]} position={[0, 7, -4]} />
                    {interestPoints.map(({ id, position }) => (
                        <InterestPoint key={id} id={id} position={position} />
                    ))}

                    <Projects position={[31, 5, 56]} img="./img/projets/landing.jpg" />
                    <Projects position={[19, 5, 56]} img="./img/projets/lineup.jpg" />
                    <Projects position={[43, 5, 56]} img="./img/projets/first.jpg" />
                    <Projects position={[31, 5, 69]} img="./img/projets/castlebloc.jpg" />
                    <Projects position={[19, 5, 69]} img="./img/projets/telepherique.jpg" />
                    <Projects position={[43, 5, 69]} img="./img/projets/cailloux.jpg" />

                    <CuboidCollider args={[60, 10, 1]} position={[0, 0, -10]} />
                    <CuboidCollider args={[60, 10, 1]} position={[0, 0, 80]} />
                    <CuboidCollider args={[50, 10, 1]} position={[-50, 0, 30]} rotation={[0, Math.PI * 0.5, 0]} />
                    <CuboidCollider args={[50, 10, 1]} position={[60, 0, 40]} rotation={[0, Math.PI * 0.5, 0]} />
                </group>
            </Physics>
        </>
    )
}
